import React from 'react';
import PropTypes from 'prop-types';
import {issueAttributesType} from '../../constants/proptype-validation';
import {connect} from '../../app/connect';
import {getCurrentViewType, isFieldManagementActive} from '../../app/selectors';
import {viewTypes} from '../../constants/view-types';
import LinkedDocumentInlineEditContainer from '../forms/LinkedDocumentInlineEditContainer';
import classNames from 'classnames';
import ChecklistCreatedFromContainer from '../common/ChecklistCreatedFromContainer';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';

const IssuePreviewDetailsTabLinkedToSection = ({
  issue,
  viewType,
  container,
  contentElementRef,
  showChecklistIndicator
}) => {
  const formClassName = classNames('IssuePreviewDetailsTabLinkedToSection');
  if (viewType === viewTypes.PROJECT) {
    return (
      <div className={formClassName}>
        <form>
          <LinkedDocumentInlineEditContainer
            issue={issue}
            container={container}
            contentElementRef={contentElementRef}
            className="IssuePreviewDetailsTabGeneralSection__field"
          />
        </form>
        {showChecklistIndicator && <ChecklistCreatedFromContainer container={contentElementRef} />}
      </div>
    );
  }
  return null;
};

IssuePreviewDetailsTabLinkedToSection.displayName = 'IssuePreviewDetailsTabLinkedToSection';

IssuePreviewDetailsTabLinkedToSection.propTypes = {
  issue: issueAttributesType,
  viewType: PropTypes.string.isRequired,
  container: PropTypes.object,
  contentElementRef: PropTypes.object,
  showChecklistIndicator: PropTypes.bool.isRequired
};

export default connect(state => ({
  viewType: getCurrentViewType(state),
  showChecklistIndicator: isFieldManagementActive(state) && featureFlags.get(FEATURE_FLAGS.CHECKLIST_INDICATOR)
}))(IssuePreviewDetailsTabLinkedToSection);
